import React, { useState } from "react";
import AddEditServiceProduct from "../../../../Components/AddEditServiceProduct/AddEditServiceProduct";
import {
  useCreateServiceMutation,
  useCreateServiceTypeMutation,
  useCreateStockLogMutation,
} from "../../../../Store/Apis/servicesApi";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";
import AddEditServiceSpec from "../../../../Components/AddEditServiceSpec/AddEditServiceSpec";
import { useSelector } from "react-redux";

const AddProduct = () => {
  const user = useSelector((state) => state.auth.user);
  const [addServiceModalShow, setAddServiceModalShow] = useState(false);
  const [createService, createServiceResponse] = useCreateServiceMutation();

  const navigate = useNavigate();

  const [createStockLog] = useCreateStockLogMutation();
  const onSubmit = (formData) => {
    createService(formData)
      .then((res) => {
        if (res?.data?.status == 200) {
          res?.data.data.serviceTypeQuantity.map((elem, i) => {
            createStockLog({
              userId: user.id,
              serviceId: elem.serviceID,
              serviceTypeId: elem.serviceTypeID,
              stockIn: elem.quantity,
              stockOut: 0,
              remark: "",
            });
          });
          toast.success(res?.data?.message, { duration: 7000 });
          navigate("/service/products");
          window.location.reload();
        } else {
          toast.error(res?.data?.message, { duration: 7000 });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // ADD SERVICE TYPE SPEC
  const AddService = () => {
    const [createServiceType, createServiceTypeResponse] =
      useCreateServiceTypeMutation();
    const handleCreateServiceSubmit = (formData) => {
      console.log(formData);
      const createServiceTypeBody = {
        outletId: formData.category,
        serviceTypeName: formData.serviceName,
        isActive: 1,
      };
      createServiceType(createServiceTypeBody)
        .then((res) => {
          console.log(res);
          if (res?.data?.status == 200) {
            toast.success(res?.data?.message, { duration: 7000 });
            setAddServiceModalShow(false);
          } else {
            toast.error(res?.data?.message, { duration: 7000 });
          }
        })
        .catch((err) => {
          toast.error(err, { duration: 7000 });
        });
    };

    return (
      <Modal
        show={addServiceModalShow}
        onHide={() => setAddServiceModalShow(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Service Specification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditServiceSpec onSubmit={handleCreateServiceSubmit} />
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <>
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col">
          <h5 className="fw-500 text-white">Add Product/Service</h5>
        </div>
        <div className="col text-end">
          <Link
            onClick={() => setAddServiceModalShow(true)}
            class="btn btn-icon btn-3 btn-white text-primary mb-0"
          >
            <i class="fa fa-plus me-2"></i> Add Service Specification
          </Link>
          <AddService />
        </div>
      </div>
      <AddEditServiceProduct onSubmit={onSubmit} />
    </>
  );
};

export default AddProduct;
